import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
var _excluded = ["color"],
  _excluded2 = ["color"],
  _excluded3 = ["color"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { spacing } from '@material-ui/system';
import { COLORS } from "../../constants/colors";
import { CardLegacy } from "../CardLegacy";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var _Card = styled(function (_ref) {
  var color = _ref.color,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CardLegacy, rest, rest.children);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.MuiCard-root {\n    padding: 8px 16px;\n    background-color: ", ";\n    color: ", ";\n\n    ", "\n  }\n"])), function (props) {
  return COLORS.notification[props.color].light;
}, function (props) {
  return COLORS.notification[props.color].dark;
}, spacing);
export var _TextWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 1;\n"])));
export var _NotificationContent = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n"])));

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var _NotificationIcon = styled(function (_ref2) {
  var color = _ref2.color,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement("div", rest, rest.children);
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-right: 12px;\n  height: 24px;\n  padding: 0px;\n  svg {\n    * {\n      fill: ", ";\n    }\n  }\n"])), function (props) {
  return COLORS.notification[props.color].dark;
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export var _CloseIcon = styled(function (_ref3) {
  var color = _ref3.color,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement("button", rest, rest.children);
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  border: none;\n  background-color: transparent;\n  align-items: center;\n  margin-left: 12px;\n  height: 24px;\n  cursor: pointer;\n  padding: 0px;\n\n  &:focus {\n    outline: none;\n  }\n\n  svg {\n    * {\n      fill: ", ";\n    }\n  }\n"])), function (props) {
  return COLORS.notification[props.color].dark;
});